var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"map googleMap",class:{ 'museum-overview-map': _vm.type == 'museum-overview' },attrs:{"id":'googleMap'+_vm.uniqueId}})
}
var staticRenderFns = []

export { render, staticRenderFns }